module.exports = __webpack_public_path__ + "static/media/medallionBanner.a4ef94b6.png";